module.exports = __webpack_public_path__ + "static/img/service-banner.494c22a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/service-banner.jpg
// module id = Bggg
// module chunks = 1